import { AxiosResponse } from "axios";
import { apiInstance } from "@/store/configureStore";

export const getEmployeeCalendarCountriesRequest = async () => {
  const response: AxiosResponse = await apiInstance.get("/calendar/countries");

  return response.data;
};
